'use client'

import { CfHeader } from '@repo/web-ui/components/cf-header'
import { Header } from 'cf-menu/components/header'
import { HamburgetMenu } from 'cf-menu/components/mobile/hamburger-menu'
import { useHomepageNavItems } from 'cf-menu/hooks/use-homepage-nav-items'
import { useTranslations } from 'next-intl'

import { HomepageMainNavigation } from './homepage-main-navigation'

interface Props {
  forceIsLoggedIn?: boolean
  forceIsAllAccess?: boolean
}

export function HomepageCfHeader({ forceIsLoggedIn, forceIsAllAccess }: Props) {
  const t = useTranslations('cf_menu')
  const navItems = useHomepageNavItems(t)

  return (
    <CfHeader
      forceIsLoggedIn={forceIsLoggedIn}
      forceIsAllAccess={forceIsAllAccess}
      isHomepage
      navItemsOverride={navItems}
    >
      {props => (
        <Header
          className={props.className}
          mainNavigation={<HomepageMainNavigation />}
          hamburgerMenu={<HamburgetMenu />}
        />
      )}
    </CfHeader>
  )
}
